import { lazy } from 'react'

import { RouteObject } from '@shared/routes'

const BalanceAI = lazy(() => import('@modules/ai/pages/BalanceAI'))
const BalanceHistoryAI = lazy(() => import('@modules/ai/pages/BalanceHistoryAI'))

const Dashboard = lazy(() => import('@modules/dashboard/pages/Dashboard'))

const EmployeesCreate = lazy(() => import('@modules/employees/pages/EmployeesCreate'))
const EmployeesCreateIA = lazy(() => import('@modules/employees/pages/EmployeeCreateIA'))
const EmployeesEdit = lazy(() => import('@modules/employees/pages/EmployeesEdit'))
const EmployeesList = lazy(() => import('@modules/employees/pages/EmployeesList'))

const CreateInvoiceNFCe = lazy(() => import('@modules/invoices/pages/CreateInvoiceNFCe'))
const InvoicesList = lazy(() => import('@modules/invoices/pages/InvoicesList'))

const Profile = lazy(() => import('@modules/profiles/pages/Profile'))

const ProductsCreate = lazy(() => import('@modules/products/pages/ProductsCreate'))
const ProductsEdit = lazy(() => import('@modules/products/pages/ProductsEdit'))
const ProductsList = lazy(() => import('@modules/products/pages/ProductsList'))

const ReturnTaxesList = lazy(() => import('@modules/return-taxes/pages/ReturnTaxesList'))

export class Routes {
  static privateRoutes: RouteObject[] = [
    // ---------- AI ----------
    {
      path: '/zeca',
      element: <BalanceAI />,
      title: 'Zeca - IA e saldo inteligente',
    },
    {
      path: '/zeca/balance-history',
      element: <BalanceHistoryAI />,
      title: 'Histórico de usos do Zeca',
    },
    // ---------- Dashboard ----------
    {
      path: '/',
      element: <Dashboard />,
      title: 'Dashboard',
    },
    // ---------- Employees ----------
    {
      path: '/employees',
      element: <EmployeesList />,
      title: 'Meus colaboradores',
    },
    {
      path: '/employees/create',
      element: <EmployeesCreate />,
      title: 'Novo colaborador',
    },
    {
      path: '/employees/create/ai',
      element: <EmployeesCreateIA />,
      title: 'Cadastrar colaborador com IA',
    },
    {
      path: '/employees/:employeeId/edit',
      element: <EmployeesEdit />,
      title: 'Edição de colaborador',
    },
    // ---------- Return Taxes ----------
    {
      path: '/return-taxes',
      element: <ReturnTaxesList />,
      title: 'Guias de impostos',
    },
    // ---------- Profile ----------
    {
      path: '/profile',
      element: <Profile />,
      title: 'Meu perfil',
    },
    // ---------- Products ----------
    {
      path: '/products',
      element: <ProductsList />,
      title: 'Produtos',
    },
    {
      path: '/products/create',
      element: <ProductsCreate />,
      title: 'Novo produto',
    },
    {
      path: '/products/:productId/edit',
      element: <ProductsEdit />,
      title: 'Edição de produto',
    },
    // ---------- Invoices ----------
    {
      path: '/invoices',
      element: <InvoicesList />,
      title: 'Notas fiscais',
    },
    {
      path: '/invoices/nfc-e/create',
      element: <CreateInvoiceNFCe />,
      title: 'Emissão de NFC-e',
    },
  ]
}
